"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleLsaErrorSchema = exports.googleLsaSandboxEventResponseSchema = exports.googleLsaSandboxEventRequestSchema = exports.googleLsaSandboxDeliveryEventSchema = exports.googleLsaSandboxInboundMessageEventSchema = exports.googleLsaManualSyncResponseSchema = exports.googleLsaManualSyncRequestSchema = exports.googleLsaSyncRunSchema = exports.googleLsaSyncStatusSchema = exports.googleLsaSyncTriggerSchema = exports.completeGoogleLsaAuthorizationResponseSchema = exports.completeGoogleLsaAuthorizationRequestSchema = exports.googleLsaAuthorizationResponseSchema = exports.configureGoogleLsaConnectionRequestSchema = exports.googleLsaConnectionResponseSchema = exports.googleLsaConnectionSchema = exports.googleLsaAccountTimezoneSchema = exports.googleAdsCustomerIdSchema = exports.googleLsaLeadChannelSummarySchema = exports.googleLsaDiagnosticsSchema = exports.googleLsaHealthStatusSchema = exports.googleLsaActivationBlockerSchema = exports.googleLsaActivationBlockerCodeSchema = exports.googleLsaConnectionStatusSchema = exports.googleLsaConnectionModeSchema = exports.googleLsaSafeErrorCodeSchema = exports.GOOGLE_LSA_SAFE_ERROR_CODES = void 0;
const zod_1 = require("zod");
const conversation_1 = require("./conversation");
exports.GOOGLE_LSA_SAFE_ERROR_CODES = [
    "GOOGLE_LSA_NOT_CONFIGURED",
    "GOOGLE_LSA_CONNECTION_NOT_FOUND",
    "GOOGLE_LSA_CONNECTION_DISABLED",
    "GOOGLE_LSA_LIVE_ACTIVATION_REQUIRED",
    "GOOGLE_LSA_OAUTH_STATE_INVALID",
    "GOOGLE_LSA_OAUTH_EXCHANGE_FAILED",
    "GOOGLE_LSA_OAUTH_SCOPE_MISSING",
    "GOOGLE_LSA_TOKEN_REFRESH_FAILED",
    "GOOGLE_LSA_PROVIDER_UNAVAILABLE",
    "GOOGLE_LSA_RATE_LIMITED",
    "GOOGLE_LSA_SYNC_FAILED",
    "GOOGLE_LSA_EVENT_INVALID",
    "GOOGLE_LSA_EVENT_REPLAYED",
    "GOOGLE_LSA_THREAD_NOT_FOUND",
    "GOOGLE_LSA_REPLY_NOT_SUPPORTED",
    "GOOGLE_LSA_REPLY_REJECTED",
];
exports.googleLsaSafeErrorCodeSchema = zod_1.z.enum(exports.GOOGLE_LSA_SAFE_ERROR_CODES);
exports.googleLsaConnectionModeSchema = zod_1.z.enum(["SANDBOX", "LIVE"]);
exports.googleLsaConnectionStatusSchema = zod_1.z.enum([
    "NOT_CONNECTED",
    "AUTHORIZING",
    "CONNECTED",
    "DISABLED",
    "NEEDS_ATTENTION",
]);
exports.googleLsaActivationBlockerCodeSchema = zod_1.z.enum([
    "LIVE_PROVIDER_ACCESS_NOT_APPROVED",
    "DEVELOPER_TOKEN_NOT_CONFIGURED",
    "OAUTH_CLIENT_NOT_CONFIGURED",
    "OAUTH_AUTHORIZATION_REQUIRED",
    "REQUIRED_SCOPE_NOT_GRANTED",
    "GOOGLE_ADS_CUSTOMER_ID_REQUIRED",
    "EXTERNAL_ACCOUNT_NOT_SELECTED",
    "REFRESH_TOKEN_NOT_AVAILABLE",
    "CONNECTION_DISABLED",
]);
exports.googleLsaActivationBlockerSchema = zod_1.z.object({
    code: exports.googleLsaActivationBlockerCodeSchema,
    message: zod_1.z.string().trim().min(1).max(300),
});
exports.googleLsaHealthStatusSchema = zod_1.z.enum([
    "UNKNOWN",
    "HEALTHY",
    "DEGRADED",
    "BLOCKED",
]);
exports.googleLsaDiagnosticsSchema = zod_1.z.object({
    health: exports.googleLsaHealthStatusSchema,
    lastSyncStartedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastSyncSucceededAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastSyncFailedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    nextSyncAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    credentialExpiresAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastErrorAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    lastSafeErrorCode: exports.googleLsaSafeErrorCodeSchema.nullable(),
    lastSafeErrorMessage: zod_1.z.string().max(500).nullable(),
});
exports.googleLsaLeadChannelSummarySchema = zod_1.z.object({
    mode: exports.googleLsaConnectionModeSchema,
    status: exports.googleLsaConnectionStatusSchema,
    activationBlockers: zod_1.z.array(exports.googleLsaActivationBlockerSchema).max(20),
    diagnostics: exports.googleLsaDiagnosticsSchema,
});
exports.googleAdsCustomerIdSchema = zod_1.z.preprocess((value) => typeof value === "string" ? value.trim().replaceAll("-", "") : value, zod_1.z
    .string()
    .regex(/^\d{10}$/, "Google Ads customer ID must contain 10 digits."));
exports.googleLsaAccountTimezoneSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(100)
    .refine((value) => {
    try {
        new Intl.DateTimeFormat("en-US", { timeZone: value }).format();
        return true;
    }
    catch {
        return false;
    }
}, "Account timezone must be a valid IANA timezone.");
exports.googleLsaConnectionSchema = exports.googleLsaLeadChannelSummarySchema.extend({
    id: zod_1.z.string().uuid(),
    businessId: zod_1.z.string().uuid(),
    enabled: zod_1.z.boolean(),
    googleAdsCustomerId: exports.googleAdsCustomerIdSchema.nullable(),
    loginCustomerId: exports.googleAdsCustomerIdSchema.nullable(),
    accountTimezone: exports.googleLsaAccountTimezoneSchema.nullable(),
    externalAccountLabel: zod_1.z.string().trim().min(1).max(160).nullable(),
    grantedScopes: zod_1.z.array(zod_1.z.string().trim().min(1).max(255)).max(50),
    defaultAssigneeMembershipId: zod_1.z.string().uuid().nullable(),
    liveActivationReady: zod_1.z.boolean(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    updatedAt: zod_1.z.string().datetime({ offset: true }),
});
exports.googleLsaConnectionResponseSchema = zod_1.z.object({
    connection: exports.googleLsaConnectionSchema.nullable(),
    canManage: zod_1.z.boolean(),
});
exports.configureGoogleLsaConnectionRequestSchema = zod_1.z
    .object({
    mode: exports.googleLsaConnectionModeSchema,
    enabled: zod_1.z.boolean().default(true),
    googleAdsCustomerId: exports.googleAdsCustomerIdSchema,
    loginCustomerId: exports.googleAdsCustomerIdSchema.nullable().default(null),
    accountTimezone: exports.googleLsaAccountTimezoneSchema,
    defaultAssigneeMembershipId: zod_1.z.string().uuid().nullable().default(null),
})
    .strict();
exports.googleLsaAuthorizationResponseSchema = zod_1.z.object({
    authorizationUrl: zod_1.z.string().url(),
    stateExpiresAt: zod_1.z.string().datetime({ offset: true }),
});
exports.completeGoogleLsaAuthorizationRequestSchema = zod_1.z
    .object({
    state: zod_1.z.string().trim().min(32).max(512),
    code: zod_1.z.string().trim().min(8).max(4_096),
})
    .strict();
exports.completeGoogleLsaAuthorizationResponseSchema = zod_1.z.object({
    connection: exports.googleLsaConnectionSchema,
});
exports.googleLsaSyncTriggerSchema = zod_1.z.enum([
    "MANUAL",
    "SCHEDULED",
    "SANDBOX",
]);
exports.googleLsaSyncStatusSchema = zod_1.z.enum([
    "QUEUED",
    "RUNNING",
    "SUCCEEDED",
    "FAILED",
]);
exports.googleLsaSyncRunSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    connectionId: zod_1.z.string().uuid(),
    trigger: exports.googleLsaSyncTriggerSchema,
    status: exports.googleLsaSyncStatusSchema,
    threadsSeen: zod_1.z.number().int().nonnegative(),
    messagesSeen: zod_1.z.number().int().nonnegative(),
    duplicateEvents: zod_1.z.number().int().nonnegative(),
    repliesReconciled: zod_1.z.number().int().nonnegative(),
    safeErrorCode: exports.googleLsaSafeErrorCodeSchema.nullable(),
    safeErrorMessage: zod_1.z.string().max(500).nullable(),
    startedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    completedAt: zod_1.z.string().datetime({ offset: true }).nullable(),
    createdAt: zod_1.z.string().datetime({ offset: true }),
});
exports.googleLsaManualSyncRequestSchema = zod_1.z
    .object({
    idempotencyKey: zod_1.z.string().uuid(),
})
    .strict();
exports.googleLsaManualSyncResponseSchema = zod_1.z.object({
    run: exports.googleLsaSyncRunSchema,
    idempotentReplay: zod_1.z.boolean(),
});
const googleLsaSandboxEventBaseSchema = zod_1.z.object({
    externalEventId: zod_1.z.string().trim().min(1).max(255),
    externalThreadId: zod_1.z.string().trim().min(1).max(255),
    providerOccurredAt: zod_1.z.string().datetime({ offset: true }),
    providerSequence: zod_1.z.string().trim().min(1).max(255).optional(),
});
exports.googleLsaSandboxInboundMessageEventSchema = googleLsaSandboxEventBaseSchema.extend({
    type: zod_1.z.literal("INBOUND_MESSAGE"),
    externalMessageId: zod_1.z.string().trim().min(1).max(255),
    externalLeadId: zod_1.z.string().trim().min(1).max(255).nullable().optional(),
    externalAccountId: zod_1.z.string().trim().min(1).max(64).nullable().optional(),
    replySupported: zod_1.z.boolean().default(true),
    contactName: zod_1.z.string().trim().min(1).max(160).optional(),
    sender: zod_1.z.string().trim().min(1).max(320),
    recipient: zod_1.z.string().trim().min(1).max(320),
    body: zod_1.z.string().trim().min(1).max(20_000),
    attachments: zod_1.z.array(conversation_1.conversationAttachmentInputSchema).max(20).default([]),
});
exports.googleLsaSandboxDeliveryEventSchema = googleLsaSandboxEventBaseSchema.extend({
    type: zod_1.z.literal("OUTBOUND_DELIVERY_UPDATE"),
    externalMessageId: zod_1.z.string().trim().min(1).max(255),
    status: zod_1.z.enum(["SENT", "DELIVERED", "FAILED"]),
    safeErrorCode: exports.googleLsaSafeErrorCodeSchema.optional(),
});
exports.googleLsaSandboxEventRequestSchema = zod_1.z.discriminatedUnion("type", [
    exports.googleLsaSandboxInboundMessageEventSchema,
    exports.googleLsaSandboxDeliveryEventSchema,
]);
exports.googleLsaSandboxEventResponseSchema = zod_1.z.object({
    accepted: zod_1.z.literal(true),
    duplicate: zod_1.z.boolean(),
    conversationId: zod_1.z.string().uuid(),
    messageId: zod_1.z.string().uuid(),
});
exports.googleLsaErrorSchema = zod_1.z.object({
    code: exports.googleLsaSafeErrorCodeSchema,
    message: zod_1.z.string().trim().min(1).max(500),
    retryable: zod_1.z.boolean(),
});
//# sourceMappingURL=google-lsa.js.map